import React from 'react'
import { SupplierOnlineManagementForm } from './styled'
import {
  Button,
  Modal,
  Section,
  InputTextarea,
  Checkbox,
  InputUpload,
  Image,
  AttachedFile,
} from '../../components'

import { comprehensiveController } from '../../apiService'
import { ICONS } from '../../themes'
import {
  STRING,
  ROUTE_PATH,
  toastFail,
  dateMonDayYearTime,
  toastActive,
  localStorageService,
} from '../../helpers'
// import FileDownload from 'js-file-download'
import { isError } from 'lodash'
import { Line } from 'rc-progress'
import { Label } from 'recharts'
import FileDownload from 'js-file-download'
export class BuyerOnlineManagementContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      onlineByID: '',
      onlineComprehensive: '',
      sections: [],
      sectionIndex: 0,
      checkValidate: false,
      userId: localStorageService.getBuyerId(),
      supplierId: '',
      modal: '',
      display: true,
      onlineSupplierAnswer: [],
      versionResponded: '',
      versionTemplate: '',
      loadingDownloadFile: [],
    }
  }

  componentDidMount = async () => {
    // console.log(this.props)
    if (this.props.match.params && this.props.match.params.templateId) {
      this.setState({
        supplierId: this.props.match.params.supplierId,
        versionResponded: this.props.match.params.versionResponded,
        versionTemplate: this.props.match.params.versionTemplate,
      })
      this.getTemplateByID(
        this.props.match.params.templateId,
        this.props.match.params.versionTemplate
      )
    } else {
      this.props.history.push(ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK)
    }
  }

  getTemplateByID = async (id, versionTemplate) => {
    this.setState({ isLoading: true })
    const res = await comprehensiveController().getOnlineID(id, versionTemplate)
    // console.log('getTemplateByID', res)
    if (res) {
      if (res === 'record not found') {
        toastFail('Not found')
        this.props.history.push('/')
      } else {
        this.getOnlineByID(
          this.props.match.params.templateId,
          this.props.match.params.supplierId,
          this.props.match.params.versionResponded,
          versionTemplate
        )
        this.setState({
          onlineByID: res,
          sections: res.online_template_section,
        })
        if (this.state.display) {
          this.getRespond(
            id,
            this.state.supplierId,
            this.state.versionResponded
          )
        }
      }
    }
    this.setState({ isLoading: false })
  }

  getOnlineByID = async (
    templateId,
    supplierId,
    versionResponded,
    versionTemplate
  ) => {
    const res = await comprehensiveController().getOnlineComprehensiveID(
      templateId,
      supplierId,
      versionResponded,
      versionTemplate
    )
    // console.log('getOnlineComprehensiveID', res)
    if (res) {
      this.setState({ onlineComprehensive: res })
    }
  }

  getRespond = async (templateId, supplierId, versionResponded) => {
    const res = await comprehensiveController().getRespond(
      templateId,
      supplierId,
      versionResponded
    )
    // console.log('getRespond', res)
    if (res) {
      await this.setState({ onlineSupplierAnswer: res.online_supplier_answer })
      this.setAnswer()
    } else {
      console.error('error')
    }
  }

  setAnswer() {
    const { sections, onlineSupplierAnswer } = this.state
    let newSections = [...sections]
    newSections.map((s, sIndex) => {
      s.isDone = true
      s.online_template_question_group.map((g, gIndex) => {
        g.online_template_question.map((q, qIndex) => {
          onlineSupplierAnswer.map((a, aIndex) => {
            if (q.id === a.question_id) {
              q.answer = a.answer ? 'yes' : 'no'
              q.comment = a.comment
              q.files = a.online_supplier_answer_file || []
              q.answerId = a.id
            }
          })
        })
      })
    })
    // console.log('newSections', newSections)
    this.setState({ sections: newSections })
  }

  setLoadingDownloadFile = file => {
    this.state.loadingDownloadFile.push({ id: file.id })
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  deleteLoadingDownloadFile = file => {
    let index = this.state.loadingDownloadFile.findIndex(x => x.id === file.id)
    this.state.loadingDownloadFile.splice(index, 1)
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  renderSection() {
    const { onlineByID, sections, sectionIndex } = this.state
    const section = sections[sectionIndex]
    return (
      <>
        <Section className="section-header">
          <div className="section-no">Section {sectionIndex + 1}:</div>
          <div className="section-title">
            <h4>{section.name}</h4>
            <small>{section.description}</small>
          </div>
        </Section>
        {section.online_template_question_group.map((item, index) =>
          this.renderGroup(item, index)
        )}
      </>
    )
  }

  renderGroup(data, gIndex) {
    return (
      <Section
        className="card"
        key={'group' + this.state.sectionIndex + gIndex}
      >
        <Section className="card-title">
          <span>
            {this.state.sectionIndex + 1}.{gIndex + 1}:
          </span>
          {data.name || '-'}
        </Section>
        <Section className="card-body">
          <ul>
            {data.online_template_question.map((item, index) =>
              this.renderQuestion(item, gIndex, index)
            )}
          </ul>
        </Section>
      </Section>
    )
  }

  renderQuestion(data, gIndex, index) {
    console.log('file : ', data.files)

    return (
      <li key={'question' + this.state.sectionIndex + gIndex + index}>
        <Section className="sub-heading">
          <span>
            {this.state.sectionIndex + 1}.{gIndex + 1}.{index + 1}:{' '}
          </span>
          {data.question}
        </Section>
        <div className="sub-body">
          <Section className="checkbox-group">
            <Checkbox
              disabled={true}
              className="is-radio-type"
              id={'answerYes' + this.state.sectionIndex + gIndex + index}
              key={'answerYes' + this.state.sectionIndex + gIndex + index}
              checked={data.answer === 'yes'}
              onChange={e => {
                data.answer = 'yes'
                data.isAnswer = true
                let newSection = [...this.state.sections]
                let newGroup = [
                  ...newSection[this.state.sectionIndex]
                    .online_template_question_group,
                ]
                newGroup[gIndex].online_template_question[index] = data
                newSection[
                  this.state.sectionIndex
                ].online_template_question_group = newGroup
                this.setState({ sections: newSection })
              }}
            >
              Yes
            </Checkbox>
            <Checkbox
              disabled={true}
              className="is-radio-type"
              id={'answerNo' + this.state.sectionIndex + gIndex + index}
              key={'answerNo' + this.state.sectionIndex + gIndex + index}
              checked={data.answer === 'no'}
              onChange={() => {
                data.answer = 'no'
                data.isAnswer = true
                let newSection = [...this.state.sections]
                let newGroup = [
                  ...newSection[this.state.sectionIndex]
                    .online_template_question_group,
                ]
                newGroup[gIndex].online_template_question[index] = data
                newSection[
                  this.state.sectionIndex
                ].online_template_question_group = newGroup
                this.setState({ sections: newSection })
              }}
            >
              No
            </Checkbox>
          </Section>
          <p>{data.requirement}</p>
          {data.comment && data.comment !== '' && (
            <Section mb={'1rem'} className="form-group">
              <label>Comment</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    disabled={true}
                    value={data.comment}
                    onChange={e => {
                      data.comment = e.target.value
                      data.isComment = true
                      let newSection = [...this.state.sections]
                      let newGroup = [
                        ...newSection[this.state.sectionIndex]
                          .online_template_question_group,
                      ]
                      newGroup[gIndex].online_template_question[index] = data
                      newSection[
                        this.state.sectionIndex
                      ].online_template_question_group = newGroup
                      this.setState({ sections: newSection })
                    }}
                    placeholder="provide a copy of supporting documentation or a brief description of such standards or requirements"
                  />
                </Section>
              </Section>
            </Section>
          )}
          {data.files && data.files.length > 0 && (
            <Section className="form-group">
              <label className="tooltip-upload">
                Attachment
                <Section className="link tooltip-attachment">
                  <Image
                    src={ICONS['icon-help.svg']}
                    alt="help"
                    tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                    useTootipFor="FileType"
                    useTootip={true}
                  />
                </Section>
              </label>
              <Section className="form-group-control">
                {data.files.length > 0 ? (
                  <AttachedFile
                    // key={i}
                    id={`attached-file-internal-file`}
                    isIcon={true}
                    isUpload={false}
                    onDownload={e => {
                      this.setLoadingDownloadFile(e)
                      this.downloadFileAttachment(e)
                    }}
                    fileList={data.files}
                    loadingDownload={this.state.loadingDownloadFile}
                  />
                ) : (
                  '-'
                )}
              </Section>
            </Section>
          )}
        </div>
      </li>
    )
  }

  countPercent() {
    const { sections } = this.state
    let countDone = 0
    for (var sIndex = 0; sIndex < sections.length; sIndex++) {
      if (sections[sIndex].isDone) {
        countDone = countDone + 1
      }
    }
    let percent = parseFloat((countDone / sections.length) * 100).toFixed(2)
    return percent
  }

  rederBusinessType(data) {
    // console.log(data)
    let businessType = ''
    data.map((btg, btgIndex) => {
      if (btgIndex === data.length - 1) {
        businessType = businessType + btg.business_type
      } else {
        businessType = businessType + btg.business_type + ','
      }
    })
    if (businessType === '') {
      businessType = '-'
    }
    return businessType
  }

  downloadFileAttachment = async file => {
    try {
      const dataFile = await comprehensiveController().downloadAnswerFile(
        file.id
      )
      const { data } = dataFile
      this.deleteLoadingDownloadFile({ id: file.id })
      FileDownload(data, file.name)
    } catch (error) {
      console.log(error)
    }
  }

  downloadAttachment = () => {
    const { onlineByID } = this.state
    const files = onlineByID.online_template_file || []

    const funcDownloadFile = async file => {
      try {
        const dataFile = await comprehensiveController().downloadTemplateFile(
          file.id
        )
        // console.log(dataFile)
        const { data } = dataFile
        FileDownload(data, file.name)
      } catch (error) {
        console.log(error)
      }
    }

    if (files.length > 0) {
      // console.log(files)
      for (var i = 0; i < files.length; i++) {
        funcDownloadFile(files[i])
      }
    }
  }

  render() {
    const {
      onlineByID,
      sections,
      sectionIndex,
      onlineComprehensive,
    } = this.state

    return (
      <React.Fragment>
        <SupplierOnlineManagementForm>
          <Section className="main-content">
            <Section className="page-topbar flex-column">
              <Section mb={'1rem'} className="page-header">
                <Section className="page-icon">
                  <Image
                    src={ICONS['icon-comprehensive- assessment.svg']}
                    alt="page icon"
                  />
                </Section>

                <Section className="title-and-breadcrumb">
                  <Section className="title">
                    {STRING.SUPPLIER_ONLINE_COMPREHENSIVE_ASSESSMENT_MANAGEMENT}
                  </Section>
                </Section>
              </Section>
              <ul>
                <li>
                  <span>Questionnaire Version :</span>
                  <span>
                    {(onlineComprehensive !== '' &&
                      dateMonDayYearTime(
                        onlineComprehensive.questionnaire_version
                      )) ||
                      '-'}
                  </span>
                </li>
                <li>
                  <span>Requested date :</span>
                  <span>
                    {(onlineComprehensive !== '' &&
                      onlineComprehensive.is_send_mail &&
                      dateMonDayYearTime(onlineComprehensive.requested_date)) ||
                      '-'}
                  </span>
                </li>
                <li>
                  <span>Response date :</span>
                  <span>
                    {onlineComprehensive !== '' &&
                    onlineComprehensive.updated_by_string !== '' &&
                    onlineComprehensive.response_date
                      ? dateMonDayYearTime(onlineComprehensive.response_date)
                      : '-'}
                  </span>
                </li>
                <li>
                  <span>By :</span>
                  <span>
                    {(onlineComprehensive !== '' &&
                      onlineComprehensive.updated_by_string) ||
                      '-'}
                  </span>
                </li>
              </ul>
            </Section>

            <Section mb={'2rem'} className="content-body">
              <Section className="btn-download">
                <Button
                  disabled={
                    this.state.onlineByID !== '' &&
                    this.state.onlineByID.online_template_file &&
                    this.state.onlineByID.online_template_file.length > 0
                      ? false
                      : true
                  }
                  onClick={() => {
                    this.downloadAttachment()
                  }}
                >
                  Download template
                </Button>
              </Section>
              <Section className="form-wrapper flex-column">
                <h2>{onlineByID.name}</h2>
                <sub>{onlineByID.description}</sub>
                <Section>
                  <div className="section-no">
                    <label> Business Type :</label>
                  </div>
                  <div className="business-type">
                    {onlineByID !== '' &&
                      onlineByID.online_business_type_group.map((item, i) => {
                        return (
                          <div key={'btg' + i}>
                            {i + 1}.
                            {this.rederBusinessType(item.online_business_type)}
                          </div>
                        )
                      })}
                  </div>
                </Section>
              </Section>
            </Section>
            <Section className="content-body border-radius-6">
              {onlineByID !== '' && this.renderSection()}

              <Section pb={'2rem'} mr={'2rem'} className="form-actions">
                {/* {sectionIndex == 0 && (
                  <Button
                    id=""
                    className="theme-solid-blue"
                    onClick={() => {
                      this.props.history.push(
                        ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK
                      )
                    }}
                  >
                    Cancel
                  </Button>
                )} */}

                {sectionIndex > 0 && (
                  <Button
                    id=""
                    className="theme-solid-blue"
                    onClick={() => {
                      this.setState({
                        checkValidate: false,
                        sectionIndex: sectionIndex - 1,
                      })
                    }}
                  >
                    Back
                  </Button>
                )}

                {sectionIndex + 1 < sections.length && (
                  <Button
                    id=""
                    className="theme-green"
                    onClick={() => {
                      this.setState({ checkValidate: true })
                      //   let isDone = this.checkValidate()
                      if (this.state.display) {
                        this.setState({
                          checkValidate: false,
                          sectionIndex: sectionIndex + 1,
                        })
                      } else {
                        // if (isDone) {
                        let newSection = [...sections]
                        newSection[sectionIndex].isDone = true
                        this.setState({
                          checkValidate: false,
                          sections: newSection,
                          sectionIndex: sectionIndex + 1,
                        })
                        // } else {
                        //   toastFail('This question is required')
                        // }
                      }
                    }}
                  >
                    Next
                  </Button>
                )}
              </Section>
            </Section>
          </Section>

          <div className="step-progress">
            <ul className="step-progress-items">
              {sections.map((item, index) => (
                <li
                  className={
                    item.isDone &&
                    index !== sectionIndex &&
                    sections.length - 1 !== index
                      ? 'step-progress-item is-done'
                      : item.isDone &&
                        index !== sectionIndex &&
                        sections.length - 1 === index
                      ? 'step-progress-item step-last-done'
                      : index === sectionIndex &&
                        sections.length - 1 !== sectionIndex
                      ? 'step-progress-item is-current'
                      : sections.length - 1 === sectionIndex
                      ? 'step-progress-item step-last-current'
                      : 'step-progress-item'
                  }
                  key={'step' + index}
                  onClick={() => {
                    if (item.isDone || this.state.display) {
                      this.setState({
                        checkValidate: false,
                        sectionIndex: index,
                      })
                    }
                  }}
                >
                  <div>Section {index + 1}</div>
                  <div>{item.name}</div>
                </li>
              ))}
            </ul>
            <div className="step-progress-items">
              <div className="step-line-wrapper">
                <Line
                  percent={this.countPercent()}
                  strokeWidth={4}
                  trailWidth={4}
                  trailColor="#F4F4F4"
                  strokeColor="#29CC6A"
                />
                <span>{this.countPercent()}%</span>
              </div>
            </div>
          </div>
        </SupplierOnlineManagementForm>
      </React.Fragment>
    )
  }
}
